import { axios, Response } from '../../index'
import { GetFavoriteChecklistResponse } from './responses/get-favorite-checklist-response'

const getFavoriteChecklists = (): Response<GetFavoriteChecklistResponse[]> => {
  return axios.get('/v1/favorites/favorites-checklists')
}

export default getFavoriteChecklists
